<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const buttonText = field<string>("buttonText", "");
const reportPath = field<string>("reportPath", "");
const automationPath = field<string>("automationPath", "");
const delaySeconds = field<number>("delaySeconds", 10);
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:send" accent="assessment">
    <EditorField :label="t('buttonTextLabel')">
      <Input v-model="buttonText" class="h-8 rounded-sm bg-muted text-[13px]" placeholder="Submit your assessment" />
    </EditorField>

    <EditorField :label="t('reportPathLabel')" :hint="t('reportPathHint')">
      <EditorPathInput
        v-model="reportPath"
        mode="existing-file"
        :scopes="['site', 'external']"
        allow-http-urls
        content-type-filter="report"
        placeholder="/reports/me"
        aria-label="Report path"
      />
    </EditorField>

    <EditorField :label="t('automationPathLabel')">
      <EditorPathInput
        v-model="automationPath"
        mode="existing-file"
        :scopes="['site']"
        content-type-filter="automation"
        placeholder="/automations/assessment"
        aria-label="Automation path"
      />
    </EditorField>

    <EditorField :label="t('delayLabel')">
      <Input type="number" min="0" v-model.number="delaySeconds" class="h-8 rounded-sm bg-muted text-[13px]" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Submit Assessment"
  buttonTextLabel: "Button Text"
  reportPathLabel: "Report Path"
  reportPathHint: "A relative/site-local path for internal navigation, or a full http/https URL."
  automationPathLabel: "Automation Path"
  delayLabel: "Delay (seconds)"
</i18n>
